import React from 'react';

export default function LoadingIndicator() {
    return (
        <div className="loading-indicator__container no-wysiwyg">
            <div className="loading-indicator__spinner"></div>
            <p className="heading-size-md">Retrieving results</p>
        </div>
    );
}
